import { defineComponent as _defineComponent } from 'vue'
import { computed } from '../../adapter-vue';
import { TUIStore, IMessageModel } from '@tencentcloud/chat-uikit-engine';
import MessageBubble from '../../components/TUIChat/message-list/message-elements/message-bubble.vue';
import { isUniFrameWork } from '../../utils/env';

interface IProps {
  message: IMessageModel;
  showStyle: string;
  bubbleClassNameList?: string[];
  blinkMessageIDList?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-plugin-layout',
  props: {
    message: { default: () => ({} as IMessageModel) },
    showStyle: { default: '' },
    bubbleClassNameList: { default: () => [] as string[] },
    blinkMessageIDList: { default: () => [] as string[] }
  },
  emits: ['resendMessage', 'handleToggleMessageItem', 'handleH5LongPress'],
  setup(__props: any, { emit: emits }) {

const props = __props as { message: IMessageModel, showStyle: string, bubbleClassNameList: string[], blinkMessageIDList: string[] }




const messageModel = computed(() => TUIStore.getMessageModel(props.message?.ID));

// The following is for external interaction such as messageTool, no special processing is required, do not change
const resendMessage = (message: IMessageModel) => {
  emits('resendMessage', message);
};
const handleToggleMessageItem = (e: any, message: IMessageModel, isLongpress = false) => {
  emits('handleToggleMessageItem', e, message, isLongpress);
};
const handleH5LongPress = (e: any, message: IMessageModel, type: string) => {
  emits('handleH5LongPress', e, message, type);
};

return { __sfc: true,props, emits, messageModel, resendMessage, handleToggleMessageItem, handleH5LongPress, MessageBubble, isUniFrameWork }
}

})